import script from "./ModalFaleConosco.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFaleConosco.vue?vue&type=script&setup=true&lang=js"

import "./ModalFaleConosco.vue?vue&type=style&index=0&id=673e4ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-673e4ef0"]])

export default __exports__